import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Comprehensive fix for ResizeObserver errors on all browsers including Safari/iOS
// Prevent the error at the source by wrapping ResizeObserver
(function() {
  const OriginalResizeObserver = window.ResizeObserver;
  
  window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
})();

// Suppress any ResizeObserver errors that still slip through
window.addEventListener('error', (e) => {
  if (e.message && e.message.toLowerCase().includes('resizeobserver')) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
}, true);

// Suppress console errors
const originalConsoleError = console.error;
console.error = function(...args) {
  if (args && args[0] && typeof args[0] === 'string' && 
      args[0].toLowerCase().includes('resizeobserver')) {
    return;
  }
  originalConsoleError.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
